import classnames from 'classnames/bind'
import { ReactNode, useCallback } from 'react'

import { LAYOUT } from '~/providers/LayoutSwitcherProvider'

import { useINPTrick } from '~/hooks/useINPTrick'

import css from './styles.module.scss'

const cx = classnames.bind(css)

type StepProps = {
  className?: string
  name?: LAYOUT
  activeClassName?: string
  icon?: ReactNode
}

export type LayoutSwitcherProps = {
  className?: string
  currentStep: string
  steps: StepProps[]
  onClickCallback?: (step: LAYOUT) => void
}

type LayoutSwitcherItemProps = {
  className?: string
  activeClassName?: string
  index?: number
  name?: LAYOUT
  onClick?: (step: LAYOUT) => void
  isActive?: boolean
  children?: ReactNode
}

function LayoutSwitcherItem({
  className,
  activeClassName,
  index,
  isActive,
  name,
  onClick,
  children,
}: LayoutSwitcherItemProps) {
  const { hasInteracted, onInteract } = useINPTrick()
  return (
    <button
      className={cx(
        className,
        css.switcher,
        isActive || hasInteracted ? activeClassName : null,
        { isActive },
      )}
      aria-label="layout-switcher"
      onClick={(e) => {
        !isActive ? onInteract(() => onClick(name)) : null
      }}>
      {children}
    </button>
  )
}

function LayoutSwitcher({
  className,
  steps,
  currentStep,
  onClickCallback,
}: LayoutSwitcherProps) {
  const onClickSwitcher = useCallback((step) => {
    onClickCallback && onClickCallback(step)
  }, [])

  return (
    <div className={cx(css.LayoutSwitcher, className)}>
      {steps?.map((step, index) => (
        <LayoutSwitcherItem
          key={`layout_switcher_item_${index}`}
          className={step?.className}
          activeClassName={step?.activeClassName}
          isActive={currentStep === step?.name}
          index={index}
          name={step?.name}
          onClick={onClickSwitcher}>
          {step?.icon}
        </LayoutSwitcherItem>
      ))}
    </div>
  )
}

LayoutSwitcher.defaultProps = {}

export default LayoutSwitcher
